<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>To Do</h2>
  <mat-dialog-content class="todo-entry-view">
    <div class="todo-entry-name-due">
      <span>
        <h3><b>{{entry.name}}</b></h3>
      </span>
      <span>
        <h4 *ngIf="!entry.markedNational"><b>District: </b>{{entry.businessUnit.buId}}</h4>
        <h4 *ngIf="entry.markedNational "><b>National Task</b></h4>
      </span>
      <span>Due: {{entry.dueDate | date:'dd MMMM yyyy'}}</span>
    </div>
    <mat-divider></mat-divider>
    <div class="todo-entry-completed">
      <div *ngIf="!entry.completed" style="color: red">
        To be completed
      </div>
      <div *ngIf="entry.completed" style="color: #008847">
        Completed: {{entry.completedDate | date:'dd MMMM yyyy'}}
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="todo-entry-description">
      <div *ngIf="entry.description!='undefined'">{{entry.description}}</div>
      <div *ngIf="entry.description=='undefined'">No description available</div>
    </div>

    <mat-divider *ngIf="entry.markedNational"></mat-divider>
    <div *ngIf="entry.markedNational && entry.parentId == null">
      <h4><b>Districts: </b> {{calculateNumCompleted(entry)}}/{{entry.children.length}}</h4>
      <span *ngFor="let child of entry.children">
        <div>
          <mat-checkbox class="todo-checkbox" [(ngModel)]="child.completed" color="primary" (click)="tickEntry(child)"></mat-checkbox>
           {{child.businessUnit.buId}}:
          <i *ngIf="child.completed" style="color: #008847">Completed on {{child.completedDate | date:'dd MMMM yyyy'}}</i>
          <b *ngIf="!child.completed" style="color: red">To be completed</b>
        </div>
      </span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="closeDialog()">Ok</button>
  </mat-dialog-actions>
</div>
